(function(){
var track=document.querySelector('[data-hero]');
if(track){
 var n=track.children.length,i=0,dots=document.querySelector('[data-dots]'),timer;
 function mark(){if(dots)[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===i)})}
 function go(k){i=(k+n)%n;track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});mark()}
 if(dots){for(var k=0;k<n;k++){(function(k){var b=document.createElement('button');b.setAttribute('aria-label','Slide '+(k+1));b.onclick=function(){go(k)};dots.appendChild(b)})(k)}mark()}
 var p=document.querySelector('[data-prev]'),x=document.querySelector('[data-next]');
 if(p)p.onclick=function(){go(i-1)};if(x)x.onclick=function(){go(i+1)};
 track.addEventListener('scroll',function(){i=Math.round(track.scrollLeft/track.clientWidth);mark()});
 if(n>1){timer=setInterval(function(){go(i+1)},5500);track.addEventListener('pointerdown',function(){clearInterval(timer)})}
}
var main=document.querySelector('[data-main-img]');
document.querySelectorAll('[data-thumb]').forEach(function(t){t.onclick=function(){
 if(main){main.src=t.dataset.src;main.removeAttribute('srcset')}
 document.querySelectorAll('[data-thumb]').forEach(function(o){o.classList.remove('on')});t.classList.add('on')}});
var sel=document.querySelector('.variant-select'),pr=document.querySelector('[data-price]');
if(sel&&pr)sel.onchange=function(){pr.textContent=sel.options[sel.selectedIndex].dataset.price};
})();
(function(){
var root=document.querySelector('.pdp');if(!root)return;
var track=root.querySelector('[data-track]'),slides=track?track.children:[],n=slides.length,idx=0;
var dots=root.querySelector('[data-slider-dots]'),thumbs=root.querySelectorAll('[data-thumb-index]');
function mark(){
 if(dots)[].forEach.call(dots.children,function(d,k){d.classList.toggle('on',k===idx)});
 thumbs.forEach(function(t,k){t.classList.toggle('on',k===idx)});
 var on=thumbs[idx];if(on)on.parentNode.scrollTo({left:on.offsetLeft-12,behavior:'smooth'});
}
function go(k){if(!n)return;idx=Math.max(0,Math.min(n-1,k));track.scrollTo({left:track.clientWidth*idx,behavior:'smooth'});mark()}
if(dots){for(var k=0;k<n;k++){(function(k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Image '+(k+1));b.onclick=function(){go(k)};dots.appendChild(b)})(k)}}
var pv=root.querySelector('[data-slide-prev]'),nx=root.querySelector('[data-slide-next]');
if(pv)pv.onclick=function(){go((idx-1+n)%n)};if(nx)nx.onclick=function(){go((idx+1)%n)};
thumbs.forEach(function(t){t.onclick=function(){go(+t.dataset.thumbIndex)}});
if(track)track.addEventListener('scroll',function(){var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==idx){idx=i;mark()}});
mark();

var form=root.querySelector('.pdp-form'),vj=root.querySelector('[data-variants]');
if(form&&vj){
 var variants=JSON.parse(vj.textContent),fs=form.querySelectorAll('.opt'),idInput=form.querySelector('[data-variant-id]'),
 priceEl=root.querySelector('[data-price]'),cmpEl=root.querySelector('[data-compare]'),btn=form.querySelector('[name=add]');
 function selected(){return [].map.call(fs,function(f){var c=f.querySelector('input:checked');return c?c.value:null})}
 function refresh(skipImg){
  var sel=selected(),v=variants.find(function(x){return x.options.every(function(o,i){return o===sel[i]})});
  fs.forEach(function(f,i){
   f.querySelector('[data-opt-label]').textContent=sel[i];
   f.querySelectorAll('input').forEach(function(inp){
    var t=sel.slice();t[i]=inp.value;
    var ok=variants.some(function(x){return x.available&&x.options.every(function(o,j){return o===t[j]})});
    inp.nextElementSibling.classList.toggle('out',!ok)})});
  if(!v){if(btn){btn.disabled=true;btn.textContent='Unavailable'}return}
  idInput.value=v.id;priceEl.textContent=v.price;if(cmpEl)cmpEl.textContent=v.compare;
  if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out'}
  if(!skipImg){history.replaceState(null,'','?variant='+v.id);
   if(v.image){for(var k=0;k<n;k++){if(+slides[k].dataset.imageId===v.image){go(k);break}}}}
 }
 form.addEventListener('change',function(){refresh(false)});refresh(true);
}
})();
(function(){
  /* Sale banner: copy-code button + optional countdown */
  document.querySelectorAll('[data-sale]').forEach(function(b){
    var cp=b.querySelector('[data-copy]');
    if(cp)cp.addEventListener('click',function(){
      var code=cp.getAttribute('data-copy'),lbl=cp.textContent;
      function done(){cp.textContent='Copied!';setTimeout(function(){cp.textContent=lbl},1600)}
      if(navigator.clipboard)navigator.clipboard.writeText(code).then(done,done);else done();
    });
    var cd=b.querySelector('[data-end]');if(!cd)return;
    var raw=(cd.getAttribute('data-end')||'').trim().replace(' ','T');
    if(!/[zZ]|[+-]\d\d:?\d\d$/.test(raw))raw+='+05:30';
    var end=Date.parse(raw);if(isNaN(end)){cd.remove();return}
    var out=cd.querySelector('[data-left]');
    function pad(x){return(x<10?'0':'')+x}
    function tick(){
      var s=Math.floor((end-Date.now())/1000);
      if(s<=0){cd.remove();clearInterval(t);return}
      var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
      out.textContent=(d>0?d+'d ':'')+pad(h)+'h '+pad(m)+'m '+pad(sec)+'s';
      cd.hidden=false;
    }
    var t=setInterval(tick,1000);tick();
  });
})();
